import { createFileRoute } from '@tanstack/react-router';
import { MasterCobrancasScreen } from '@/mobile/master/screens/MasterCobrancasScreen';

export const Route = createFileRoute('/m/master/cobrancas')({
  component: MasterCobrancasScreen,
});
